import { defineMessages } from 'react-intl';

export const editSnippetModalMessages: {
	titleEdit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editSuccessFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editErrorFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editErrorFlagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	titleEdit: {
		id: 'snippets.snippetEditorModal.titleEdit',
		defaultMessage: 'Edit block template',
		description:
			'The text is shown as the heading at the top of the modal dialog that allows a user to edit an existing block template.',
	},
	saveButton: {
		id: 'snippets.snippetEditorModal.saveButton',
		defaultMessage: 'Save',
		description:
			'The text is shown on the primary submit button in the Edit Block Template modal. When the user clicks this button, it saves the changes made to the existing block template.',
	},
	editSuccessFlagTitle: {
		id: 'snippets.snippetEditorModal.editSuccessFlagTitle',
		// oxlint-disable-next-line eslint-core/no-restricted-syntax
		defaultMessage: 'Template "{snippetName}" updated',
		description: 'Success flag title shown when a block template has been updated',
	},
	editErrorFlagTitle: {
		id: 'snippets.snippetEditorModal.editErrorFlagTitle',
		defaultMessage: 'Could not update the template',
		description: 'Error flag title shown when a block template update fails',
	},
	editErrorFlagDescription: {
		id: 'snippets.snippetEditorModal.editErrorFlagDescription',
		defaultMessage: 'Please try again',
		description: 'Error flag description shown when a block template update fails',
	},
});
